<template>
  <div class="mt-1 mb-1">
    <h4 class="mb-75">
      {{ $t('settings.profile.reservation.book-for') }}
    </h4>
    <b-form-radio-group
      id="customer-group"
      v-model="localValue"
      @change="changed"
    >
      <b-row class="match-height">
        <b-col
          v-for="customer in customers"
          :key="customer.id"
          cols="12"
          md="6"
          class="mb-50"
        >
          <label
            class="rounded p-1 cursor-pointer h-100"
            :class="{'border-primary': localValue === customer.id, 'border': localValue !== customer.id}"
          >
            <span class="d-block">
              <b-form-radio
                :id="`customer-${customer.id}`"
                :value="customer.id"
                name="customer"
                class="mb-0 float-left"
              />

              <span class="font-weight-bold font-medium-1">
                {{ customer.firstName }} {{ customer.lastName }}
              </span>
            </span>
          </label>
        </b-col>
      </b-row>
    </b-form-radio-group>
  </div>
</template>

<script>
export default {
  name: 'CustomerSelector',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    customers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localValue: null,
    }
  },
  watch: {
    value(newValue) {
      if (newValue === this.localValue) {
        return
      }
      this.localValue = newValue
    },
  },
  methods: {
    changed(value) {
      this.$emit('input', value)
    },
  },
}
</script>
